export const CATEGORY_ICON_OPTIONS = [
  { value: 'bike',             label: 'Xe đạp / Xe máy' },
  { value: 'wrench',           label: 'Phụ kiện / Dụng cụ' },
  { value: 'battery-charging', label: 'Pin / Sạc' },
  { value: 'shield',           label: 'Bảo hộ / An toàn' },
  { value: 'zap',              label: 'Điện / Tốc độ' },
  { value: 'package',          label: 'Hộp / Gói hàng' },
  { value: 'tag',              label: 'Nhãn / Khuyến mãi' },
  { value: 'settings',         label: 'Cài đặt / Linh kiện' },
]
